// Dependencies
const anime = require("animejs");
const flubber = require("flubber");

// Galaxy Outer
window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M422.33076,29.97152c107.2157-56.39356,197.9572-15.19174,257.041,52.099C755.1318,168.354,749.2145,304.4837,638.60652,358.1823c-157.89407,76.65531-198.42474-35.62226-400.85625,25.677C125.86788,417.739,45.37534,292.65846,69.826,195.0944,102.89608,63.13684,262.91918,113.81919,422.33076,29.97152Z",
        "M318.88989,43.40332C200.18537,19.22318,124.57573,84.14461,86.65385,165.26718c-48.62525,104.01925-4.8965,233.07,116.31188,253.7145C375.992,448.45187,383.52664,329.32078,595.02352,331.599,711.91628,332.85819,754.2419,190.2653,703.49719,103.42316,634.86385-14.03275,495.38338,79.35509,318.88989,43.40332Z"
    ];

    let path = document.querySelector("#intro #galaxyOuterMask");
    let interpolator = flubber.fromCircle(500, 200, 5, paths[0]);
    let progress = { interpolation: 0 };

    path.setAttribute("d", interpolator(0));

    anime({
        targets: progress,
        interpolation: 1000,
        easing: "easeInOutQuad",
        duration: 2250,
        delay: 750,
        round: 10,
        update: () => path.setAttribute("d", interpolator(progress.interpolation / 1000))

    }).finished.then(() => {

        let interpolator = flubber.interpolate(paths[0], paths[1]);
        let progress = { interpolation: 0 };

        anime({
            targets: progress,
            interpolation: 1000,
            easing: "easeInOutQuad",
            duration: 6000,
            loop: true,
            round: 10,
            direction: "alternate",
            update: () => path.setAttribute("d", interpolator(progress.interpolation / 1000))
        });

    });

});

// Galaxy Inner
window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M195.9,293.03c41.14-17.17,88.72-35.82,111.62-129.07c19.81-90.72,29.98-51.89,66.54-75.47c19.46-12.55,17.64-45.92,37.67-58.82c23.87-15.37,33.23-12.78,46.7-19.52c17.17-8.6,7.11-77.36,42.82-89.47c164.01-55.64-18.24-116.79-10.53-116.55c56.04,1.73,361.27-154.7,319.87,333.01c-8.48,99.92-84.13,21.26-146.42,30.12c-46.2,6.57-55.39,44.12-74.17,46.51c-23.17,2.96-25.58-23.95-55.75-20.03c-18.29,2.37-15.32,19.95-33.58,23.63c-16.33,3.29-23.46-22.98-60.32-7.09c-37.36,16.1-87.28,72.22-239.12,108.48",
        "M195.9,293.03C237.04,275.86,310,266,320.67,170.67c14.67-78,32.1-48.42,68.67-72c20-19.33-7.33-46,18-78.67C431.2,4.63,446.53,6.75,460,0c17.17-8.6,5.55-67.22,41.26-79.34c164.01-55.64-18.24-116.79-10.53-116.55c56.04,1.73,564.04-131.92,311.27,287.22c-52.67,87.33-52.02,126.67-114.67,144c-46.2,6.57-52.67-41.24-71.45-38.84c-23.17,2.96-16.55,44.18-56.55,32.18c-29.33-17.33-37.33-41.33-70-32.18c-26,22.18-12.67,22.84-44.67,43.51c-34.67,26.67-91.59,42.48-243.43,78.74"
    ]

    let path = document.querySelector("#intro #galaxy-inner");
    let interpolator = flubber.interpolate(paths[0], paths[1]);
    let progress = { interpolation: 0 };

    anime({
        targets: progress,
        interpolation: 10000,
        easing: "easeInOutQuad",
        duration: 20000,
        loop: true,
        round: 10,
        direction: "alternate",
        update: () => path.setAttribute("d", interpolator(progress.interpolation / 10000))
    });

});

// Sextant
window.addEventListener("DOMContentLoaded", () => {

    (function loop() {

        let sextant = document.querySelector("#sextant #symbol");
        let stars = document.querySelectorAll("#sextant #stars path");

        // Initial state
        sextant.style.strokeDashoffset = 100;

        stars.forEach(star => {

            Object.assign(star.style, {
                opacity: 0,
                transform: "translateY(1rem)"
            });

        });

        // Animate!
        anime({
            targets: stars,
            opacity: [
                { value: 1, duration: 600 }
            ],
            translateY: [
                { value: -0.5, duration: 600 },
                { value: 0, duration: 1000 }
            ],
            delay: anime.stagger(500),
            easing: "easeInOutQuad"

        }).finished.then(() => {

            anime({
                targets: stars,
                opacity: 0,
                duration: 750,
                delay: 500,
                easing: "easeInOutQuad"
            });

            anime({
                targets: sextant,
                strokeDashoffset: 0,
                easing: "easeInOutQuad",
                duration: 2000
            }).finished.then(() => {

                anime({
                    targets: sextant,
                    strokeDashoffset: 100,
                    easing: "easeInOutQuad",
                    duration: 1000,
                    delay: 2000

                }).finished.then(loop);

            });

        });

    })();

});

// 20 years, balloon 2
window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M114.28 238.34C138.43 343.19 163.21 452.89 138 560a315.22 315.22 0 0 1-31 81.07.45.45 0 0 0 .78.45c52.25-94 47.11-205.79 27.92-308.12-6-32-13.28-63.64-20.58-95.32a.45.45 0 0 0-.87.24z",
        "M114.28,238.34C127.58,296,143.38,356,133.38,415.5c-2.32,13.78-6.65,27-10.15,40.47a338.85,338.85,0,0,0-7.59,37c-3.31,23.07-3.65,46.62.66,69.58,5.41,28.86,18.2,55.43,35.57,79,0.34,0.46,1.12,0,.78-0.45-16-21.73-28.26-46.07-34.2-72.52-5.49-24.46-5.52-49.78-2-74.53a333.84,333.84,0,0,1,7.29-36.21c3.43-13.43,7.82-26.55,10.25-40.22,4.91-27.71,4.08-56.06.47-83.87-4.19-32.28-11.95-64-19.25-95.63a0.45,0.45,0,0,0-.87.24h0Z"
    ];

    let cord = document.querySelector("#balloon-2-cord");
    let interpolator = flubber.interpolate(paths[0], paths[1]);
    let progress = { interpolation: 0 };

    anime({
        targets: progress,
        interpolation: 1000,
        easing: "easeInOutQuad",
        duration: 6000,
        loop: true,
        round: 10,
        direction: "alternate",
        update: () => cord.setAttribute("d", interpolator(progress.interpolation / 1000))
    });

});

// 20 years, balloon 0
window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M194 248.14c-8.44 71.11-3.11 142.8 6.48 213.51 9.84 72.57 24 144.51 32.47 217.28 4.73 40.7 7.6 81.64 6.94 122.63a.45.45 0 0 0 .9 0c1.16-72-8.68-143.49-19.94-214.43C209.37 515.06 196.36 443 192 370.09c-2.41-40.65-2-81.48 2.83-122 .07-.57-.83-.57-.9 0z",
        "M190.55,258a1088.78,1088.78,0,0,1-4.92,135.65c-3.63,36.86-9.15,73.47-14.8,110.07-9.15,59.3-18.65,119.69-8.9,179.56,5.92,36.35,18.73,71,35.74,103.61a0.45,0.45,0,0,0,.78-0.45c-15.58-29.82-27.67-61.43-34.07-94.53-5.58-28.88-6.69-58.37-5-87.69,1.78-30.94,6.39-61.64,11.09-92.24,5.4-35.17,10.9-70.32,14.76-105.7A1099.57,1099.57,0,0,0,191.45,258a0.45,0.45,0,0,0-.9,0h0Z"
    ];

    let cord = document.querySelector("#balloon-0-cord");
    let interpolator = flubber.interpolate(paths[0], paths[1]);
    let progress = { interpolation: 0 };

    anime({
        targets: progress,
        interpolation: 1000,
        easing: "easeInOutQuad",
        duration: 10000,
        loop: true,
        round: 10,
        direction: "alternate",
        update: () => cord.setAttribute("d", interpolator(progress.interpolation / 1000))
    });

});

// Plane
// window.addEventListener("DOMContentLoaded", () => {

//     const paths = [
//         "M78.83 203.05a8 8 0 0 1-8 8 8 8 0 0 1 8 8 8 8 0 0 1 8-8 8 8 0 0 1-8-8z"
//     ];

//     let trajectory = anime.path("#plane-backdrop .trajectory");
//     let plane = document.querySelector("#plane");

//     (function loop() {

//         plane.style.opacity = 0;

//         anime({
//             targets: plane,
//             translateX: {
//                 value: trajectory("x"),
//                 duration: 4000
//             },
//             translateY: {
//                 value: trajectory("y"),
//                 duration: 4000
//             },
//             // rotate: {
//             //     value: trajectory("angle"),
//             //     duration: 4000
//             // },
//             scale: {
//                 value: [1, 0.6],
//                 duration: 4000
//             },
//             opacity: {
//                 value: [0, 1],
//                 duration: 800
//             },
//             easing: "easeInOutQuad",

//         }).finished.then(() => {

//             anime({
//                 targets: plane,
//                 opacity: 0,
//                 easing: "easeInOutQuad",
//                 duration: 2000,
//                 endDelay: 1000

//             }).finished.then(loop);

//         });

//     })();

// });

// Work Session
window.addEventListener("DOMContentLoaded", () => {

    // const paths = [
    //     "M43.53 18.32S43 11 48.09 6.52 60.31.29 69.88 7c0 0 4.52 5.14 8.52 9 0 0 3.74 3.55 7.81 3.17s9.34 3.83 9.9 8.26c0 0 .14 1.51 3.17 2.29 5.22 1.35 17.45 7.92 12 21.37S77.86 72.33 64.2 62.7 51.35 35.21 51.07 32.55c-.75-7.03-6.87-8.55-7.54-14.23z",
    //     "M43.53,18.32S43,11,48.09,6.52,60.31,0.29,69.88,7a28.68,28.68,0,0,1,5.49,8.21,12.7,12.7,0,0,0,.81,6.66c1.55,3.79,4.3,12.37,9.74,14.75,0,0,4.74,3.13,12.26,1.88,5.32-.88,18.56-0.82,13.15,12.63S77.86,72.33,64.2,62.7,51.35,35.21,51.07,32.55C50.32,25.52,44.2,24,43.53,18.32Z",
    //     "M43.53,18.32S43,11,48.09,6.52,60.31,0.29,69.88,7a28.68,28.68,0,0,1,5.49,8.21,12.7,12.7,0,0,0,.81,6.66c1.55,3.79,2.13,9.57,9.89,12.79a12.76,12.76,0,0,1,9.49,9.95c1.35,6.92,11.94,7.7,9.13,20.64C100.05,86.53,74.42,77.53,64.2,62.7,54.71,48.94,51.35,35.21,51.07,32.55,50.32,25.52,44.2,24,43.53,18.32Z"
    // ];

    // let womanHair = document.querySelector('#work-session [data-name="woman-hair"]');
    // let index = 0;

    // (function loop() {

    //     if (!paths[index]) {

    //         index = 0;

    //     }

    //     let initial = paths[index];
    //     let end = paths[index + 1] ? paths[index + 1] : paths[0];

    //     let interpolator = flubber.interpolate(initial, end);
    //     let progress = { interpolation: 0 };

    //     anime({
    //         targets: progress,
    //         interpolation: 1000,
    //         easing: "easeInOutQuad",
    //         duration: 5000,
    //         round: 10,
    //         update: () => womanHair.setAttribute("d", interpolator(progress.interpolation / 1000))

    //     }).finished.then(() => {

    //         index++;

    //         loop();

    //     })

    // })();



});